import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Header from '../../Header';
import Footer from '../../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import config from "../../common/Config";

const VatSuggestionBox = ({vat_id}) =>{

	const accessToken = localStorage.getItem('accessToken');

	const [vatOptions, setVatOptions] = useState([]);
	const [vatFilteredOptions, setVatFilteredOptions] = useState([]);
	const [vatValue, setVatValue] = useState('');
	const [vatInputValue, setVatInputValue] = useState('');

	const vatHandleChange = (selectedOption) => {
	    setVatValue(selectedOption);
	};

	const vatHandleInputChange = (inputValue) => {
	    setVatInputValue(inputValue);
	    const newFilteredOptions = vatOptions.filter(option =>
	        option.label.toLowerCase().includes(inputValue.toLowerCase())
	    );
	    setVatFilteredOptions(newFilteredOptions);
	};

	const fetchVatList = async () => {
	  		
		const apivatUrl = `${config.API_URL}/get_vat`;
		try {
			const response = await fetch(apivatUrl, {
				method : 'POST',
				headers : {
					authorization : `Bearer ${accessToken}`,
				}
			});
			const data = await response.json();
			//console.log(data);
			const formattedOptions = data.data.map(item => ({
	        label: item.name,  
	  		value: item.id,    
	    }));
	    setVatOptions(formattedOptions);
	    setVatFilteredOptions(formattedOptions);

		}catch(error){
			console.error('api fail error fetching vats');
		}
	};

	useEffect(() => {

		if (accessToken === null){
	   		window.location.href = `${config.BASE_URL}/login`; 
	    	return;
		}
		fetchVatList();

	},[]);

	useEffect(() => {
        if (vat_id) {
            const selectedVat = vatOptions.find(option => option.value === vat_id);
            setVatValue(selectedVat || null);
        }
    }, [vat_id, vatOptions]);

	return(
		<>
			<Select
			    isClearable
			    onInputChange={vatHandleInputChange}
			    onChange={vatHandleChange}
			    options={vatFilteredOptions}
			    placeholder="Select"
			    value={vatValue}
			    name="tax_rate" className='promoselect abovedd'
			/>


		</>
	);

}
export default VatSuggestionBox;